import { t } from '../../../i18n.es.js';
import React from 'react';
import { styled, SvgIcon, Currency } from '@teko/ui';
import { Flex, Box } from 'reflexbox';
import { DetailGifts, Quantity } from '../DetailGifts/DetailGifts.es.js';
import { DiscountPromotion } from '../DiscountPromotion/DiscountPromotion.es.js';

const StyledIcon = styled(SvgIcon)(({ theme }) => `
  margin-left: 5px;
  --button-icon-color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const StyledCurrency = styled(Currency)`
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const StyledVoucherName = styled.span`
  color: #ed2101;
  font-weight: 500;
`;
const DefaultPromotions = ({
  defaultGifts,
  defaultPromotions,
  discount,
  defaultVouchers = []
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, discount > 0 && /* @__PURE__ */ React.createElement(Flex, {
    marginTop: 2
  }, /* @__PURE__ */ React.createElement(Box, {
    width: "8%"
  }, /* @__PURE__ */ React.createElement(StyledIcon, {
    name: "promotion",
    size: 20
  })), /* @__PURE__ */ React.createElement(Box, {
    width: "92%"
  }, t("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: discount
  }))), !!defaultGifts.length && /* @__PURE__ */ React.createElement(DetailGifts, {
    gifts: defaultGifts
  }), defaultPromotions.map((promo, index) => /* @__PURE__ */ React.createElement(DiscountPromotion, {
    key: index,
    promotion: promo
  })), defaultVouchers.map((voucher, index) => /* @__PURE__ */ React.createElement(Flex, {
    key: index,
    marginTop: 2
  }, /* @__PURE__ */ React.createElement(Box, {
    width: "8%"
  }, /* @__PURE__ */ React.createElement(StyledIcon, {
    name: "promotion",
    size: 20
  })), /* @__PURE__ */ React.createElement(Box, {
    width: "92%"
  }, t("T\u1EB7ng"), /* @__PURE__ */ React.createElement(Quantity, null, "x", voucher.quantity), " ", /* @__PURE__ */ React.createElement(StyledVoucherName, null, voucher.name)))));
};

export { DefaultPromotions };
